export const CHAT_MEDIA_GENERATION_WIDTH = 512;
export const CHAT_MEDIA_GENERATION_HEIGHT = 768;
export const CHAT_MEDIA_ASPECT_RATIO = '2 / 3';
